/**
 * /requests — the ActivityPage for NON-ADMIN designated grantors (round 7):
 * the backend let them Decide all along, but the queue lived behind
 * RequireAdminRoute. The server's reviewer flag (computed by the same gate
 * Decide uses) decides what renders; every RPC underneath re-enforces it.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useAccessRequests } from '../Access/hooks';
import { ActivityPage } from './ActivityPage';
export function ReviewerRequestsPage() {
    const { data, isLoading } = useAccessRequests('pending');
    if (isLoading) {
        return /*#__PURE__*/ _jsx("p", {
            className: "p-6 text-sm text-muted-foreground",
            children: "Loading…"
        });
    }
    if (!data?.reviewer) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "p-6",
            "data-testid": Testids.adminActivity.notReviewer,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text-sm",
                    children: "This page is for your organization’s access reviewers."
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mt-1 text-xs text-muted-foreground",
                    children: "Need access to something? Ask from the page itself — the request reaches the right people."
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-auto max-w-5xl p-6",
        children: /*#__PURE__*/ _jsx(ActivityPage, {})
    });
}
